import type { OrderAdminNoteAdminDto } from '@/backend/market'
import { NoteMiniEntity } from '../../domain/entities/NoteMiniEntity'
import { mapEntityProperties } from '@/utils/mapEntityProperties'

export class NoteMiniModel extends NoteMiniEntity {
  constructor(dataDto: OrderAdminNoteAdminDto) {
    super()
    mapEntityProperties<NoteMiniEntity>(this, dataDto)
  }
}
